import { Flex } from '@nilohealth/core-ui'
import { getCareProviderAsset } from '@providers/providers.logic'
import { useCareProvider } from '@providers/providers.hooks'

import { NavbarLogo } from './navbar.styles'
import NavbarProfileMenu from './navbar-profile-menu'

const NavbarProfile = () => {
  const domain = typeof window !== 'undefined' ? window?.location?.host : ''

  const { careProvider } = useCareProvider(domain)

  return (
    <Flex align="center" gap="xxxsmall">
      <NavbarProfileMenu />

      <NavbarLogo as="img" alt="Care provider logo" src={getCareProviderAsset(careProvider, 'logo_positive')} />
    </Flex>
  )
}

export default NavbarProfile
